import { createSlice } from "@reduxjs/toolkit";
import { CommissionAllocationResponse } from "../../shared/types";
import { CommissionAllocationsThunks } from "../thunks";

interface State {
  commissionAllocations: CommissionAllocationResponse[];
  isLoading: boolean;
}

const initialState: State = {
  commissionAllocations: [],
  isLoading: true,
};

export const CommissionAllocationsSlice = createSlice({
  name: "CommissionAllocations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(CommissionAllocationsThunks.fetchItems.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      CommissionAllocationsThunks.fetchItems.fulfilled,
      (state, action) => {
        state.commissionAllocations = action.payload;
        state.isLoading = false;
      }
    );
    builder.addCase(
      CommissionAllocationsThunks.fetchItems.rejected,
      (state) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      CommissionAllocationsThunks.createItem.fulfilled,
      (state, action) => {
        state.commissionAllocations.push(action.payload);
      }
    );
    builder.addCase(
      CommissionAllocationsThunks.updateItem.fulfilled,
      (state, action) => {
        const index = state.commissionAllocations.findIndex(
          (resource) => resource.id === action.payload.id
        );
        state.commissionAllocations[index] = action.payload;
      }
    );
    builder.addCase(
      CommissionAllocationsThunks.deleteItem.fulfilled,
      (state, action) => {
        state.commissionAllocations = state.commissionAllocations.filter(
          (resource) => resource.id !== action.payload
        );
      }
    );
  },
});

export default CommissionAllocationsSlice.reducer;
